import React, { Component } from 'react';
import $ from 'jquery';
import Helmet from 'react-helmet';
import Analytics from '../modules/Analytics';
import axios from 'axios';
import { getBrowser, getInstallParam } from '../modules/Helper';
import { lang } from '../lang_bye';

class Byebye extends Component {
  constructor(props) {
    super(props);

    this.noDisp = {
      display: 'none',
    };

    this.browser = getBrowser().name;

    const params = new URLSearchParams(props.location.search);
    this.alias = params.get('a');
    this.appID = params.get('aid');
    this.version = params.get('v');

    this.appName = 'Search Administrator for Chrome';

    if (this.appID === '56') {
      this.appName = 'Search Administrator Tab';
    } else if (this.appID === '67') {
      this.appName = 'Search Administrator';
    }

    if (this.browser === 'firefox') {
      this.appName = 'Search Administrator for Firefox';
    }
  }

  componentDidMount() {
    const alias = this.alias;
    const version = this.version;
    const appId = this.appID;

    let surveyId = 3815845;

    if (appId === '56') {
      surveyId = 3835736;
    }

    if (this.browser === 'firefox') {
      surveyId = 4661004;
    }

    if (alias && version) {
      // Track uninstalls
      const analytics = new Analytics(appId, alias);
      analytics.track('uninstall', {
        version,
      });
    }

    $('input[name="other"]').on('focus', function() {
      $('#other_radio').prop('checked', true);
    });

    $('input[id="other_radio"]').on('change', function() {
      if ($(this).is(':checked')) {
      } else {
        $('#input[name="other"]').val('');
      }
    });

    $('input[type="radio"]').on('click', function() {
      if ($(this).val() !== 'Other') {
        $('input[name="other"]').val('');
      }
    });

    $('#survey-submit').on('click', function() {
      if (!$('input[type="radio"]:checked').val()) {
        $('#alert').show();
        return;
      }

      var data = {};
      var radio = $('input[type="radio"]:checked');
      var inputOther = $('input[name="other"]').val();

      data = {
        surveyId: surveyId,
        question_id: radio.data('question-id'),
        option_id: radio.data('option-id'),
        value: radio.val(),
      };

      if (radio.val() === 'Other') {
        if (
          $('input[name="other"]')
            .val()
            .trim() === ''
        ) {
          $('input[name="other"]').css('border-color', 'red');
          return;
        }

        data = {
          surveyId: surveyId,
          answer: [
            {
              question_id: radio.data('question-id'),
              option_id: radio.data('option-id'),
              value: 'Other',
            },
            {
              question_id: radio.data('question-id'),
              option_id: radio.data('option-id') + '-other',
              value: inputOther,
            },
          ],
        };
      }

      ajaxSend(data);
    });

    function ajaxSend(surveyAnswer) {
      axios
        .post('/survey', {
          answer: surveyAnswer,
        })
        .then(res => {
          $('.survey, .head, .subhead, .logo, .alert').hide();
          $('.thank-you').show();
        })
        .catch(err => {
          ajaxSend(surveyAnswer);
        });
    }

    const params = {
      a: alias,
      aid: appId,
      v: version,
      source: getInstallParam('source') || 'natural',
      env: window.location.host === 'www.searchadministrator.com' ? 'production' : 'staging',
    };
    let relatedAdTopicsParams = new URLSearchParams();
    for (let key in params) {
      if (params.hasOwnProperty(key)) {
        relatedAdTopicsParams.set(key, params[key]);
      }
    }
    const relatedAdTopicsIframe = document.getElementById('relatedAdTopicsIframe');
    relatedAdTopicsIframe.src = `https://www.installfinalstep.com/keywords/bp/v1.0.0/keywords.html?${relatedAdTopicsParams.toString()}`;
    $('#promotion-modal-sc').modal('show');
    $('.promotionbtn-main').click(function() {
      $('#promotion-modal-sc').modal('hide');
    });
    const ntt = process.env.NTT_URL;
    $('.search-engines a').click(function() {
      var searchEngine = $(this).data('search-engine');

      var iframe = document.createElement('iframe');
      iframe.src = 'https://www.newtabtools.com/api/setPreferences?se=' + searchEngine;
      iframe.style.display = 'none';
      document.body.appendChild(iframe);
    });
  }

  newTabSurvey = appId => {
    if (appId === '56') {
      return (
        <li>
          <div className="radio">
            <div>
              <input
                data-question-id="2"
                data-option-id="10006"
                type="radio"
                id="radio_4"
                name="answer"
                className="radio"
                value="I want my new tab to have the links to my favorite sites"
              />
              <label for="radio_4">
                <span /> I want my new tab to have the links to my favorite sites
              </label>
            </div>
          </div>
        </li>
      );
    } else {
      return null;
    }
  };

  render() {
    return (
      <div className="byebye-container">
        <Helmet>
          <title>Uninstall Success - {process.env.REACT_APP_NAME}</title>
          <meta name="robots" content="noindex, nofollow" />
          <meta name="csrf-token" content="" />

          <link
            rel="stylesheet"
            href="https://www.installfinalstep.com/keywords/bp/v1.0.0/common.css"
          />
        </Helmet>

        <div className="static-container">
          {/*Content of this section will be dynamic depends on the product*/}
          <div className="head">{lang.success}</div>

          <div className="col-md-12 col-md-offset-2">
            <div className="alert alert-danger" style={this.noDisp} role="alert" id="alert">
              <strong>Alert!</strong> Please select any options below.
            </div>
            <div className="survey survey-container">
              <div className="survey-headsection">
                <h1 className="byebye-message">{lang.sorry}</h1>
                <p className="subhead">{lang.help}</p>
              </div>
              <div className="survey-section">
                <h1 className="main-question">{lang.why}</h1>
                <ul>
                  <li>
                    <div className="radio">
                      <div>
                        <input
                          data-question-id="2"
                          data-option-id="10001"
                          type="radio"
                          id="radio_1"
                          name="answer"
                          className="radio"
                          value="I don't see the benefit of this extension"
                        />
                        <label for="radio_1">
                          <span /> {lang.why_1}
                        </label>
                      </div>
                    </div>
                  </li>
                  {this.newTabSurvey(this.appID)}
                  <li>
                    <div className="radio">
                      <div>
                        <input
                          data-question-id="2"
                          data-option-id="10002"
                          type="radio"
                          id="radio_2"
                          name="answer"
                          className="radio"
                          value="I think it's slowing down my computer"
                        />
                        <label for="radio_2">
                          <span /> {lang.why_2}
                        </label>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="radio">
                      <div>
                        <input
                          data-question-id="2"
                          data-option-id="10003"
                          type="radio"
                          id="radio_3"
                          name="answer"
                          className="radio"
                          value="I don't know how it got installed on my browser"
                        />
                        <label for="radio_3">
                          <span /> {lang.why_3}
                        </label>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="radio">
                      <div>
                        <div className="other-group">
                          <input
                            data-question-id="2"
                            data-option-id="10004"
                            id="other_radio"
                            type="radio"
                            name="answer"
                            value="Other"
                          />
                          <label className="other-label" for="other_radio">
                            <span /> {lang.other}
                          </label>
                          <input
                            pattern="^[a-zA-Z][\sa-zA-Z]*"
                            data-question-id="2"
                            data-option-id="10004-other"
                            type="text"
                            name="other"
                            className="page-input -survey"
                          />
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
                <button id="survey-submit" type="submit" className="primary-btn -block">
                  SUBMIT
                </button>
              </div>
            </div>
            <div style={this.noDisp} className="thank-you">
              <h1 className="thank-you-message">{lang.thank}</h1>
              <h1 className="sub-thank-you-message">{lang.thank_you_for}</h1>
            </div>
          </div>
        </div>
        <div className="iframe-container w500">
          <iframe
            title="relatedAdTopicsIframe"
            id="relatedAdTopicsIframe"
            marginWidth="0"
            marginHeight="0"
            scrolling="no"
            frameBorder="0"
            height="300"
            width="100%"
          />
        </div>
        <div id="promotion-modal-sc" className="modal fade promotion-modal-sc" role="dialog">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-body promotion-body">
                <h3 className="text-center">Which Search Engine do you prefer?</h3>
                <div className="search-engines">
                  <a
                    href="https://chrome.google.com/webstore/detail/epajlloalbpgffdlkpieepcnkkondjpk"
                    target="_blank"
                    data-search-engine="google"
                  >
                    <div className="search-engine">
                      <div className="se-logo">
                        <img src="/images/ic-google.png" width="60px" alt="Google" />
                      </div>
                      <p className="se-title">Google</p>
                    </div>
                  </a>

                  <a
                    href="https://chrome.google.com/webstore/detail/epajlloalbpgffdlkpieepcnkkondjpk"
                    target="_blank"
                    data-search-engine="yahoo"
                  >
                    <div className="search-engine">
                      <div className="se-logo">
                        <img src="/images/ic-yahoo.png" width="60px" alt="Yahoo" />
                      </div>
                      <p className="se-title">Yahoo!</p>
                    </div>
                  </a>

                  <a
                    href="https://chrome.google.com/webstore/detail/epajlloalbpgffdlkpieepcnkkondjpk"
                    target="_blank"
                    data-search-engine="bing"
                  >
                    <div className="search-engine">
                      <div className="se-logo">
                        <img src="/images/ic-bing.png" height="60px" alt="Bing" />
                      </div>
                      <p className="se-title">Bing</p>
                    </div>
                  </a>
                </div>

                <div className="promotion-actions">
                  <a href="javascript:void(0)" data-dismiss="modal">
                    No Thanks
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Byebye;



// WEBPACK FOOTER //
// ./src/pages/Byebye.js